const $ = jQuery.noConflict();

const customTabsWithSlider = () => {
	// Cache DOM
	const $window = $(window);
	const section = $('.team-slider');
	const tabsWrapper = section.find('.tabs-wrapper');
	const tabs = tabsWrapper.find('.tabs-wrapper__single-tab');
	const tabsNav = section.find('.tabs-wrapper__nav');
	const tabsNavItems = tabsNav.find('.tabs-wrapper__nav-item');
	let isInitialized = false;

	// Functions
	function initialize() {
		isInitialized = true;

		const navItem = tabsNavItems.first();
		const color = navItem.data('active-color');
		tabsNavItems.removeClass('active').css('color', '').find('span.btn-strikethrough').css('background-color', '');
		navItem.addClass('active').css('color', color).find('span.btn-strikethrough').css('background-color', color);

		tabs.first().addClass('tab--current');
		tabs.slice(1).children('.tabs-wrapper__text-col').addClass('tab--hidden-up');
		tabs.slice(1).children('.tabs-wrapper__image-col').addClass('tab--hidden-down');
	}

	function disableButtons() {
		tabsNavItems.attr('disabled', true);
	}

	function enableButtons() {
		tabsNavItems.attr('disabled', false);
	}

	function tabsNavClick(e) {
		// Change Button Color
		tabsNavItems.each(function () {
			const that = this;
			$(that).removeClass('active')
				.css('color', '')
				.find('span.btn-strikethrough')
				.css('background-color', '');

			if (that === $(e.target).closest('.tabs-wrapper__nav-item')[0]) {
				const color = $(that).data('active-color');
				$(that).addClass('active')
					.css('color', color)
					.find('span.btn-strikethrough')
					.css('background-color', color);
			}
		});
	}

	function showNextTab(e) {
		const tabID = $(e.target).closest('.tabs-wrapper__nav-item').data('tab-id');
		const tab = tabs.filter(function () {
			return $(this).data('tab-id') === tabID;
		});
		const textCol = tab.find('.tabs-wrapper__text-col');
		const imageCol = tab.find('.tabs-wrapper__image-col');

		tab.addClass('tab--current');
		textCol.removeClass('tab--hidden-up');
		imageCol.removeClass('tab--hidden-down');
	}

	function hideCurrentTab(e) {
		const tab = tabsWrapper.find('.tab--current');
		const textCol = tab.find('.tabs-wrapper__text-col');
		const imageCol = tab.find('.tabs-wrapper__image-col');

		tab.removeClass('tab--current');
		textCol.addClass('tab--hidden-down');
		imageCol.addClass('tab--hidden-up');

		textCol.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
			$(this).off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
			textCol.addClass('tab--no-transition tab--hidden-up').removeClass('tab--hidden-down');
			imageCol.addClass('tab--no-transition tab--hidden-down').removeClass('tab--hidden-up');

			setTimeout(() => {
				textCol.removeClass('tab--no-transition');
				imageCol.removeClass('tab--no-transition');
				enableButtons();
			}, 25);
		});

		showNextTab(e);
	}

	function bindNavButtons() {
		tabsNavItems.on('click', (e) => {
			if ($(e.target).closest('.tabs-wrapper__nav-item').data('tab-id') === tabsWrapper.find('.tab--current').data('tab-id')) {
				return false;
			}
			disableButtons();
			tabsNavClick(e);
			hideCurrentTab(e);
		});
	}

	function deinitialize() {
		isInitialized = false;
		tabsNavItems.off();
		tabs.removeClass('tab--current');
		tabs.find('.tabs-wrapper__text-col').removeClass('tab--hidden-up tab--hidden-down');
		tabs.find('.tabs-wrapper__image-col').removeClass('tab--hidden-up tab--hidden-down');
	}

	function fireCustomTabs() {
		if ($window.width() >= 1200) {
			if (!isInitialized) {
				initialize();
				bindNavButtons();
			}
		} else {
			if (isInitialized) {
				deinitialize();
			}
		}
	}

	// Bind events

	window.addEventListener('resize', () => {
		fireCustomTabs();
	});

	fireCustomTabs();
};

export default customTabsWithSlider;
